import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import './MainView.css';
import '../../assets/css/style.css';
import "react-circular-progressbar/dist/styles.css";
import 'react-tooltip/dist/react-tooltip.css';

import MapView from "../MapView/MapView.jsx";
import HeaderOptions from "../HeaderOptions/HeaderOptions.jsx";
import SidebarRight from "../SidebarRight/SidebarRight.jsx";
import Settings from "../Settings/Settings.jsx";
import LeftNavigationBar from "../LeftNavigationBar/LeftNavigationBar.jsx";
import ExportCreator from "../ExportCreator/ExportCreator.jsx";
import CollectionsView from "../CollectionsView/CollectionsView.jsx";
import FeaturesBar from "../OrderCreator/FeaturesBar/FeaturesBar.jsx";
import SearchView from "../SearchView/SearchView.jsx";
import { resetOrdersSlice } from "../../slices/orderSlice.js";
import { resetMapSlice } from "../../slices/mapSlice.js";
import OrderCreation from "../OrderCreator/OrderCreator.jsx";
import SuccessMessage from "../SuccessMessage/SuccessMessage.jsx";
import { resetSearchSlice } from "../../slices/searchSlice.js";
import MultiSearchView from "../MultiSearchView/MultiSearchView.jsx";

const MainView = () => {

  const displayView = useSelector(state => state.map.displayView);
  const collectionsView = useSelector(state => state.map.collectionsView);
  const isSearchView = useSelector(state => state.map.searchView);
  const isMultiSearchView = useSelector(state => state.map.multiSearchView);
  const isExportsview = useSelector(state => state.map.exportsView);
  const isSuccessMessage = useSelector(state => state.orderDetails.showSuccessMessage);

  const [isMainPage, setIsMainPage] = useState(true);
  const [isOrderCreationPage, setIsOrderCreationPage] = useState(false);

  const [collectionElement, setCollectionElement] = useState({ status: "", name: "", subName: "", idNum: 0, details: [] });
  const [isSelectedTopBarItem, setIsSelectedTopBarItem] = useState({ Collection: false, Archive: false, Configuration: false, Comparison: false, Visualization: false });
  const [isAddNewProviderModal, setIsAddNewProviderModal] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const dispatch = useDispatch();

  const props = {
    isMainPage,
    collectionElement,
    isSelectedTopBarItem,
    isOrderCreationPage,
    showSuccessMessage,
    successMessage,
    isAddNewProviderModal,
    setIsMainPage,
    setCollectionElement,
    setIsSelectedTopBarItem,
    setIsOrderCreationPage,
    setShowSuccessMessage,
    setSuccessMessage,
    setIsAddNewProviderModal,
  };

  useEffect(() => {
    return (() => {
      dispatch(resetOrdersSlice());
      dispatch(resetSearchSlice());
      dispatch(resetMapSlice());
    });
  }, [dispatch]);

  const getDisplayViews = () => {
    if (displayView === 'explorerView' || displayView === 'drawView') {
      const isDrawView = displayView === 'drawView';
      return (
        <>
          <LeftNavigationBar />
          {(!isExportsview || isDrawView) && <HeaderOptions props={props} />}
          {!isDrawView && <SidebarRight props={props} />}
          {!isDrawView && isSuccessMessage && <SuccessMessage />}
          {!isDrawView && collectionsView && <CollectionsView props={props} />}
          {!isDrawView && !(isSearchView || isExportsview) && <Settings />}
          {!isDrawView && isSearchView && <SearchView />}
          {!isDrawView && isExportsview && <ExportCreator />}
          {!isDrawView && isMultiSearchView && <MultiSearchView />}
          {isDrawView && <FeaturesBar />}
        </>
      )
    } else if (displayView === 'createOrderView') {
      return (
        <>
          <OrderCreation />
        </>
      )
    }
  };

  return (
    <>
      <div className="mainView" style={isAddNewProviderModal ? { filter: "blur(20px)" } : {}}>
        <MapView />
        {getDisplayViews()}
      </div>
    </>
  );
};

export default MainView;
